module.exports = __webpack_public_path__ + "img/pdf.2dcd360e.svg";